import { articles, categories } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured).slice(0, 4);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            编辑团队精心挑选的优质内容，每一篇都不容错过
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featured.map((article) => {
            const cat = categories.find((c) => c.slug === article.category);
            return <ArticleCard key={article.slug} article={article} category={cat} />;
          })}
        </div>
      </div>
    </section>
  );
}